module.exports = __webpack_public_path__ + "img/km.kmf07a34b.svg";